import { Box, FormControl, Radio, RadioGroup, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import React from 'react'

function ACCustomEvaluation({
  matchingUpload,
  handleClose,
  allEvalData,
  customValue,
  handleCustomEval,
  customDisabled,
}) {
  const customEvalList = []

  allEvalData?.map((item) => {
    if (item?.participant_match_type_id === 4) customEvalList.push(item)
  })

  return (
    <>
      <AdxFormModal
        open={matchingUpload}
        onClose={handleClose}
        handleClose={handleClose}
        sxModal={{ minWidth: 600 }}
        childPadding={false}
        title={'Add from custom matching evaluation'}
        subtitle={' Choose one evaluation and upload matching CSV'}
      >
        <Box sx={{ minHeight: 300 }}>
          <FormControl>
            {customEvalList?.map((item, index) => (
              <RadioGroup value={customValue} onChange={handleCustomEval} key={index}>
                <AdxFormControlLabel
                  type="fill"
                  selected={customValue}
                  value={item.id}
                  control={
                    <Radio
                      color="alternate"
                      checked={customDisabled?.some(
                        (disabledItem) => disabledItem.title === item.title
                      )}
                    />
                  }
                  label={item.title}
                  disabled={customDisabled?.some(
                    (disabledItem) => disabledItem.title === item.title
                  )}
                />
              </RadioGroup>
            ))}
          </FormControl>
        </Box>

        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          backgroundColor="white.main"
          borderTop="1px solid"
          borderTopColor="gray-line.main"
          gap={2}
          sx={{ pt: 2, px: 3 }}
        >
          <AdxButton variant={'contained'} sx={{ width: 1 }} onClick={handleClose}>
            Cancel
          </AdxButton>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default ACCustomEvaluation
